<template>
  <wizard-summary-option
    v-if="wizard.askAddonCpanel"
    name="Imunify360"
    :value="wizard.siNo(wizard.addonImunify)"
    edit-step="WizardStepStack"
    ouia-id="wizard-summary-imunify"
  />

  <wizard-summary-option
    v-if="wizard.askAddonCpanel"
    name="LiteSpeed"
    :value="wizard.siNo(wizard.addonLiteSpeed)"
    edit-step="WizardStepStack"
    ouia-id="wizard-summary-litespeed"
  />
</template>

<script lang="ts" setup>
import WizardSummaryOption from './wizard-summary-option.vue';
import { useWizard } from '@/wizard';

const wizard = useWizard();
</script>
